jQuery( function ( $ ) {
	var $document = $( document ),
		ajaxurl   = window.ajaxurl;

	$document.on(
		'carbon-fields.register-container-type___',
		function () {
			alert()
		}
	);

	/**
	 * Collapse/expand complex fields via click by complex header.
	 */
	$document.on(
		'click',
		'.cf-complex__group-head',
		function () {
			var $this          = $( this ),
				$group         = $this.parent( '.cf-complex__group' ),
				$group_body    = $group.find( '.cf-complex__group-body' ),
				$group_toggler = $group.find( '.cf-complex__group-action:eq(2)' ).find( '.dashicons-before' );

			if ( $group_body.attr( 'hidden' ) ) {
				$group_body.removeAttr( 'hidden' );
				$group_toggler.removeClass( 'dashicons-arrow-down' );
				$group_toggler.addClass( 'dashicons-arrow-up' );
			} else {
				$group_body.attr( 'hidden', true );
				$group_toggler.addClass( 'dashicons-arrow-down' );
				$group_toggler.removeClass( 'dashicons-arrow-up' );
			}
		}
	);

	$document.on(
		'click',
		'#whisk_api_sync',
		function () {

			$( '<div />' ).html( 'Are you sure?' ).dialog({
				title: 'Confirmation',
				resizable: false,
				height: "auto",
				width: 300,
				modal: true,
				buttons: {
					Confirm: function() {
						$.post( {
							url: ajaxurl,
							data: {
								action: 'whisk_import_recipes'
							}
						} );
						$( this ).dialog( "close" );
					},
					Cancel: function() {
						$( this ).dialog( "close" );
					}
				}
			});
		}
	);
} );
